export default __webpack_public_path__ + "static/landing-page-banner-07b2573b4347b9fbc5a1a4d6ce12ffaf.webp";